<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-list-item-title class="secondary--text font-weight-bold">{{ booking.company.name }}</v-list-item-title>
				<v-tooltip bottom>
					<template #activator="{ on, attrs }">
						<v-list-item-subtitle class="black--text subtitle-2 font-weight-bold" v-bind="attrs" v-on="on"
							>{{ booking.booking_dates[0] }} - {{ booking.booking_dates[booking.booking_dates.length - 1] }}</v-list-item-subtitle
						>
					</template>
					<span>
						<v-list-item-group>
							<v-list-item-subtitle v-for="date in booking.booking_dates" :key="date" class="subtitle-2 font-weight-bold">{{ date }}</v-list-item-subtitle>
							<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">{{ start_time }} - {{ end_time }}</v-list-item-subtitle>
							<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
						</v-list-item-group>
					</span>
				</v-tooltip>
				<v-tooltip v-if="booking.status == 'cancelled'" bottom>
					<template #activator="{ on, attrs }">
						<v-list-item-subtitle :class="['red--text', 'lighten-1', 'font-weight-bold']"
							>{{ booking.status }}
							<v-icon color="primary" dark v-bind="attrs" small v-on="on"> help </v-icon>
						</v-list-item-subtitle>
					</template>
					<span
						><v-row
							><v-col
								>This booking was cancelled by {{ booking.cancelledBy == 'professional' ? 'you' : 'the practice' }} on
								{{ dateFormattedMomentjs(booking.updatedAt) }}</v-col
							></v-row
						></span
					>
				</v-tooltip>
				<v-list-item-subtitle v-else :class="['primary--text', 'lighten-1', 'font-weight-bold']">{{ booking.status }}</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="viewBooking(booking)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';
import store from '@/store';

export default {
	name: 'LocumBookingHistoryCard',
	components: {},
	props: {
		booking: { type: Object, required: true },
	},

	data: () => ({
		showTimes: true,
		start_time: '',
		end_time: '',
	}),

	mounted() {
		this.getTimes();
	},

	methods: {
		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		viewBooking(bookingInfo) {
			const {
				booking_dates,
				booking_dates_times,
				company,
				start_time,
				end_time,
				lunch,
				notes,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			} = bookingInfo;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				booking_dates_times,
				id: bookingId,
				profession,
				rates,
				experience,
				accountid,
				skills,
				request_dates,
			};
			store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewUpcomingBooking' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.booking.start_time;
			this.end_time = this.booking.end_time;
			for (let index = 0; index < this.booking.request_dates.length; index++) {
				if (
					moment(this.booking.request_dates[index].start_time).format('HH:mm') !== this.booking.start_time ||
					moment(this.booking.request_dates[index].end_time).format('HH:mm') !== this.booking.start_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},
	},
};
</script>
